// extracted by mini-css-extract-plugin
export var component = "Contracts-module--component--ZTJn-";
export var contracts = "Contracts-module--contracts--wwjm0";
export var description = "Contracts-module--description--Y07il";